/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, OnInit, Input, ElementRef, OnDestroy } from '@angular/core';
import { interfaces } from '@leandredev/adaptivai-common-lib';
import { DataService } from 'src/app/dataService/dataService.service';
import { mergeMap, map, startWith } from 'rxjs/operators';
import { AutoCompleteComponent } from '@leandredev/common-ng16/components';

@Component({
  selector: 'app-userrole-form-auto-complete',
  templateUrl: './UserRole.component.html',
  styleUrls: ['./UserRole.component.scss']
})
export class UserRoleFormAutoCompleteComponent extends AutoCompleteComponent<interfaces.IUserRole> implements OnInit, OnDestroy {
  private _filterQuery = '';
  @Input()
  public set filterQuery(value: string) {
    this._filterQuery = value;
  }
  public get filterQuery(): string {
    return this._filterQuery;
  }

  @Input()
  public get hasOverriddenData(): boolean {
    return this._hasOverriddenData;
  }
  public set hasOverriddenData(value: boolean) {
    this._hasOverriddenData = value;
    if (!value) {
      return;
    }
    this.unsubscribePformCtrl();
    if (this.OverriddenData) {
      this.filteredData = this.OverriddenData;
    }
  }
  private _hasOverriddenData = false;

  @Input()
  public get OverriddenData(): interfaces.IUserRole[] {
    return this._OverriddenData;
  }
  public set OverriddenData(value: interfaces.IUserRole[]) {
    this._OverriddenData = value;
    if (!value || !this.hasOverriddenData) {
      return;
    }
    this.filteredData = value;
  }
  private _OverriddenData: interfaces.IUserRole[] = [];

  constructor(protected dataService: DataService) {
    super();
    this.httpServiceBase = dataService.api.collections.UserRole;

    if (this.hasOverriddenData) {
      return;
    }
    this.pformCtrlSub = this._formCtrl.valueChanges
      .pipe(
        startWith(null),
        mergeMap((value) => {
          let query = '';
          const limit = `30/$limit/`;
          if (typeof value === 'string') {
            if (value) {
              value = value.trim();
              query = `name/${value}/i/$regex`;
            } else {
              query = '*';
            }
          } else {
            query = '*';
          }
          if (this.filterQuery) {
            query = `${query}/${this.filterQuery}`;
          }

          return this.httpServiceBase.get(`${query}/${limit}`);
        }),

        map((result) => {
          if (!this.pformCtrlSub) {
            return;
          }
          if (this.hasOverriddenData) {
            this.unsubscribePformCtrl();
            this.filteredData = this.OverriddenData;
            return;
          }
          this.filteredData = result.response;
        })
      )
      .subscribe();
  }

  private unsubscribePformCtrl(): void {
    if (!this.pformCtrlSub) {
      return;
    }
    this.pformCtrlSub.unsubscribe();
  }
}
